(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grouped-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.cggReady) return;
      root.dataset.cggReady = 'true';

      var state = { cut: 'all', colour: 'all', size: '' };
      var count = root.querySelector('[data-cgg-count]');
      var empty = root.querySelector('[data-cgg-empty]');
      var groups = root.querySelectorAll('[data-cgg-group]');

      function press(selector, attribute, value) {
        root.querySelectorAll(selector).forEach(function (button) {
          button.setAttribute('aria-pressed', button.getAttribute(attribute) === value ? 'true' : 'false');
        });
      }

      function apply() {
        var total = 0;
        groups.forEach(function (group) {
          var visible = 0;
          group.querySelectorAll('[data-cgg-card]').forEach(function (card) {
            var show =
              (state.cut === 'all' || card.dataset.cut === state.cut) &&
              (state.colour === 'all' || card.dataset.colour === state.colour) &&
              (state.size === '' || card.dataset.sizes.indexOf('|' + state.size + '|') !== -1);
            card.hidden = !show;
            if (show) visible += 1;
          });
          var tile = group.querySelector('[data-cgg-tile]');
          if (tile) tile.hidden = visible % 2 === 0;
          group.hidden = visible === 0;
          total += visible;
        });
        if (count) {
          var text = total === 1 ? count.dataset.textOne : count.dataset.textOther;
          count.textContent = text.replace('[count]', total);
        }
        if (empty) empty.hidden = total !== 0;
        press('[data-cgg-cut]', 'data-cgg-cut', state.cut);
        press('[data-cgg-colour]', 'data-cgg-colour', state.colour);
      }

      root.addEventListener('click', function (event) {
        var cut = event.target.closest('[data-cgg-cut]');
        var colour = event.target.closest('[data-cgg-colour]');
        if (cut) state.cut = cut.dataset.cggCut;
        if (colour) state.colour = colour.dataset.cggColour;
        if (cut || colour) apply();
      });

      var size = root.querySelector('[data-cgg-size]');
      if (size) {
        size.addEventListener('change', function () {
          state.size = size.value;
          apply();
        });
      }
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-cgg]').forEach(init);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-looks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-looks')) {
    customElements.define(
      'collection-looks',
      class CollectionLooks extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const toggle = this.querySelector('[data-looks-toggle]');
          if (!toggle) return;
          toggle.addEventListener(
            'click',
            () => {
              const paused = this.toggleAttribute('data-paused');
              toggle.setAttribute('aria-pressed', String(paused));
            },
            { signal: this.controller.signal }
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.reviewsReady) return;
      root.dataset.reviewsReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(tab, focus) {
        tabs.forEach(function (other) {
          var selected = other === tab;
          other.setAttribute('aria-selected', selected ? 'true' : 'false');
          other.tabIndex = selected ? 0 : -1;
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            select(next, true);
          }
        });
      });
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-collection-reviews]').forEach(init);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-2"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const viewToggle = document.querySelector('[data-view-toggle]');
    const gridContainer = document.querySelector('.product-grid-container');

    if (!viewToggle || !gridContainer) return;

    const buttons = viewToggle.querySelectorAll('[data-view]');

    const applyViewToCards = (view) => {
      const cards = gridContainer.querySelectorAll('.product-grid__item');

      cards.forEach((card) => {
        const gallery = card.querySelector('.card-gallery') || card;
        if (!gallery) return;

        const images = gallery.querySelectorAll('img');
        if (images.length < 2) return;

        if (view === 'model') {
          images[0].style.display = 'none';
          images[1].style.display = '';
        } else {
          images[0].style.display = '';
          images[1].style.display = 'none';
        }
      });
    };

    const setActiveView = (view) => {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.view === view);
      });
      applyViewToCards(view);
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setActiveView(btn.dataset.view);
      });
    });

    // initial state – default to Product (first image)
    setActiveView('product');

    // re-apply on AJAX updates (filters, pagination)
    const observer = new MutationObserver(() => {
      const activeBtn = viewToggle.querySelector('.is-active');
      const currentView = activeBtn ? activeBtn.dataset.view : 'product';
      applyViewToCards(currentView);
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stl-page')) {
    /**
     * Highlights the look in view in the switcher and drives the mobile sticky bar, which mirrors
     * the active look's state and calls its addLook() method.
     */
    class StlPage extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;
      #frame = 0;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        window.addEventListener('scroll', this.#schedule, { signal, passive: true });
        window.addEventListener('resize', this.#schedule, { signal, passive: true });
        this.addEventListener('stl:look-state', this.#schedule, { signal });
        this.querySelector('[data-stl-bar-button]')?.addEventListener('click', this.#onBarClick, { signal });
        this.addEventListener('click', this.#onJumpClick, { signal });
        this.#schedule();

        const target = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
        if (target?.tagName === 'STL-LOOK' && this.contains(target)) {
          window.addEventListener('load', () => this.#correct(target), { once: true, signal });
        }
      }

      /** @param {MouseEvent} event */
      #onJumpClick = (event) => {
        const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
        if (!(link instanceof HTMLAnchorElement) || event.defaultPrevented) return;
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target || target.tagName !== 'STL-LOOK') return;
        event.preventDefault();
        history.pushState(null, '', link.hash);
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        this.#whenScrollStops(() => {
          this.#correct(target);
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        });
      };

      /**
       * Runs the callback once the page has stopped scrolling (unchanged for two frames in a row),
       * so corrections never interrupt a smooth scroll that is still running.
       * @param {() => void} callback
       */
      #whenScrollStops(callback) {
        let last = -1;
        let still = 0;
        const started = performance.now();
        const check = () => {
          const y = window.scrollY;
          still = y === last ? still + 1 : 0;
          last = y;
          if (still >= 2 || performance.now() - started > 3000) callback();
          else setTimeout(check, 80);
        };
        setTimeout(check, 80);
      }

      /**
       * After a jump, nudges the page if a fixed or sticky element (such as a sticky header)
       * covers the top of the look.
       * @param {Element} look
       */
      #correct(look) {
        const top = look.getBoundingClientRect().top;
        const margin = parseFloat(getComputedStyle(look).scrollMarginTop) || 0;
        let covered = 0;
        for (const element of document.elementsFromPoint(window.innerWidth / 2, 1)) {
          if (this.contains(element) || element === document.body || element === document.documentElement) continue;
          const position = getComputedStyle(element).position;
          if (position === 'fixed' || position === 'sticky') {
            covered = Math.max(covered, element.getBoundingClientRect().bottom);
          }
        }
        const wanted = covered + margin;
        if (Math.abs(top - wanted) > 4) window.scrollBy({ top: top - wanted });
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
        cancelAnimationFrame(this.#frame);
        document.body.classList.remove('stl-bar-visible');
      }

      #schedule = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#update());
      };

      #activeLook() {
        const line = window.innerHeight * 0.4;
        let active = null;
        for (const look of this.querySelectorAll('stl-look')) {
          if (look.getBoundingClientRect().top <= line) active = look;
        }
        return active;
      }

      #onBarClick = () => {
        const look = this.#activeLook();
        if (look && 'addLook' in look && typeof look.addLook === 'function') look.addLook();
      };

      #update() {
        const active = this.#activeLook();

        for (const link of this.querySelectorAll('[data-stl-switch]')) {
          if (!(link instanceof HTMLElement)) continue;
          const current = Boolean(active && link.dataset.stlSwitch === active.id);
          if (current) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }

        const tiles = this.querySelector('[data-stl-tiles]');
        const tilesGone = !tiles || tiles.getBoundingClientRect().bottom < 0;
        this.querySelector('.shop-the-look__switcher')?.classList.toggle('is-stuck', tilesGone);

        const bar = this.querySelector('[data-stl-bar]');
        if (!(bar instanceof HTMLElement)) return;

        const mobile = window.matchMedia('(max-width: 989px)').matches;
        const button = active?.querySelector('[data-stl-full-look]');
        const rect = button?.getBoundingClientRect();
        const buttonVisible = Boolean(rect && rect.top < window.innerHeight && rect.bottom > 0);
        const inSection = this.getBoundingClientRect().bottom > window.innerHeight * 0.6;
        const show = Boolean(mobile && active && button && tilesGone && !buttonVisible && inSection);

        bar.hidden = !show;
        document.body.classList.toggle('stl-bar-visible', show);
        if (!show || !active || !('state' in active)) return;

        const state = /** @type {any} */ (active).state;
        const name = bar.querySelector('[data-stl-bar-name]');
        const total = bar.querySelector('[data-stl-bar-total]');
        const barButton = bar.querySelector('[data-stl-bar-button]');
        if (name) name.textContent = state.name;
        if (total) total.textContent = state.total;
        if (barButton) barButton.textContent = state.label;
      }
    }

    customElements.define('stl-page', StlPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stl-related-products')) {
    /**
     * Fills the recommendations rail with Shopify product recommendations for each look product,
     * skipping products already shown and stopping at the per-rail maximum.
     */
    class StlRelatedProducts extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;

      connectedCallback() {
        if (!this.hasAttribute('data-recommendations')) return;
        this.#abort = new AbortController();
        this.#load(this.#abort.signal);
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
      }

      /** @param {AbortSignal} signal */
      async #load(signal) {
        const rail = this.querySelector('[data-stl-recs]');
        const track = this.querySelector('[data-stl-recs-track]');
        if (!(rail instanceof HTMLElement) || !track) return;

        const max = Number(this.dataset.max) || 8;
        const seen = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
        const productIds = (this.dataset.productIds || '').split(',').filter(Boolean);
        const intents = (this.dataset.intents || 'related').split(',').filter(Boolean);
        const urls = [];
        for (const intent of intents) {
          for (const productId of productIds) {
            const url = new URL(this.dataset.url || '', window.location.origin);
            url.searchParams.set('product_id', productId);
            url.searchParams.set('section_id', this.dataset.sectionId || '');
            url.searchParams.set('intent', intent);
            url.searchParams.set('limit', '10');
            urls.push(url);
          }
        }

        const results = await Promise.allSettled(
          urls.map(async (url) => {
            const response = await fetch(url, { signal });
            return response.ok ? response.text() : '';
          })
        );
        if (signal.aborted) return;

        const parser = new DOMParser();
        let count = 0;
        for (const result of results) {
          if (count >= max) break;
          if (result.status !== 'fulfilled' || !result.value) continue;
          const doc = parser.parseFromString(result.value, 'text/html');
          for (const item of doc.querySelectorAll('[data-stl-item]')) {
            if (count >= max) break;
            if (!(item instanceof HTMLElement)) continue;
            const id = item.dataset.productId;
            if (!id || seen.has(id)) continue;
            seen.add(id);
            track.append(document.importNode(item, true));
            count += 1;
          }
        }

        if (count > 0) {
          rail.hidden = false;
          this.hidden = false;
        }
      }
    }

    customElements.define('stl-related-products', StlRelatedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
